// extracted by mini-css-extract-plugin
export var button = "_5x-7";
export var buttonRow = "_5x-6";
export var fadeIn = "_5x-1";
export var gradient = "_5x-0";
export var panel = "_5x-2";
export var panelIn = "_5x-3";
export var subtitle = "_5x-5";
export var title = "_5x-4";